// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vue-content-placeholders/dist/vue-content-placeholders.css
// module id = 425
// module chunks = 0